// extracted by mini-css-extract-plugin
export default {"tooltipText":"Tooltip_tooltipText__hdixi","tooltipWrapper":"Tooltip_tooltipWrapper__M-6oE","tooltipTriangle":"Tooltip_tooltipTriangle__oynx4"};